<template>
    <div v-show="loginUser && loginUser.uid">
        <c-header></c-header>
        <div class="container">
            <div class="page-container"
                  :class="{
                      'menu-hide': menuHide
                  }">
                <c-menu></c-menu>
                <div class="page-content-wrapper">
                    <div class="page-content tab-content">
                        <router-view transition="fade" transition-mode="out-in"></router-view>
                    </div>
                </div>
            </div>
        </div>

        <c-select-img-win></c-select-img-win>
        <c-select-video-win></c-select-video-win>
        <c-select-audio-win></c-select-audio-win>
        <c-select-article-win></c-select-article-win>
        <c-select-model3d-win></c-select-model3d-win>
        <c-select-unity3d-win></c-select-unity3d-win>
        <c-player></c-player>
    </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

import $ from 'jquery';
import AppJS from '../assets/global/scripts/app';
import LayoutJS from '../assets/layouts/layout/scripts/layout';

import '../assets/global/scripts/bootstrap';
import '../assets/global/scripts/ajaxfileupload';

import cHeader from '../views/header';
import cMenu from '../views/menu';
import cSelectImgWin from '../components/select-img-win';
import cSelectVideoWin from '../components/select-video-win';
import cSelectAudioWin from '../components/select-audio-win';
import cSelectArticleWin from '../components/select-article-win';
import cSelectModel3dWin from '../components/select-model3d-win';
import cSelectUnity3dWin from '../components/select-unity3d-win';

import cPlayer from '../components/player';

export default {
    mounted: function(){
        if(location.pathname==='/'){
          location.href='/web-mgr/'
        }
        AppJS.init();
        LayoutJS.init();
        this.initGroups();
        this.initLoginUser();
        this.getPermission();
    },
    components: {
      cHeader,
      cMenu,
      cSelectImgWin,
      cSelectVideoWin,
      cSelectAudioWin,
      cSelectArticleWin,
      cSelectModel3dWin,
      cPlayer,
      cSelectUnity3dWin
    },
    computed: mapState([
        'mainMenu',
        'menuHide',
        'loginUser'
    ]),
    methods: {
        ...mapActions([
            'initGroups',
            'initLoginUser',
            'getPermission'
        ])
    }
}
</script>

<style>
  @import "~vue-snotify/styles/material.css";
  @import '../assets/css/main.css';
  @import '../assets/css/grid.css';

.list-group {
  max-height: 600px;
  overflow-y: scroll;
}
</style>
